import styles from './Positions.module.scss';
import OPEN_POSITIONS from '../../data/open_positions.json';
import { Box, Text, Heading, useBreakpointValue, Badge, Separator } from '@chakra-ui/react';
import { RxExternalLink } from "react-icons/rx";
import { useNavigate } from 'react-router-dom';
import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';

const Positions = () => {
    const navigate = useNavigate();
    const iconSize = useBreakpointValue({ base: 18, md: 24, lg: 26 });

    return (
        <Box minH="100vh" display="flex" flexDirection="column">
            <Navbar />

            <Box
                flex="1"
                px={[4, 8, 12, 24]}
                maxW="1400px"
                mx="auto"
                w="full"
                mb={[8, 10]}
            >

                <Heading
                    as="h1"
                    size={["2xl", "4xl"]}
                    fontWeight="bold"
                    mt={[8, 10]}
                    mb={[1, 2]}
                    color="blackAlpha.900"
                    lineHeight={["1.2", "1.1"]}
                    textTransform="uppercase"
                >
                    Open Positions
                </Heading>
                <Text
                    ml='2px'
                    color="gray.600"
                    fontSize={["md", "lg", "xl"]}
                    mb={[8, 10]}
                    fontWeight="500"
                >
                    Showing {OPEN_POSITIONS.length} Jobs
                </Text>
                <Box as="ul" listStyleType="none" p={0}>
                    {OPEN_POSITIONS.map((position, idx) => (
                        <Box
                            key={idx}
                            as="li"
                            mb={[4, 6]}
                            fontSize={["18px", "24px", "28px"]}
                            fontWeight="medium"
                        >
                            <Box
                                className={styles.link}
                                onClick={() => navigate(`/${position.applicationId}`)}
                                css={{
                                    borderRadius: "2px",
                                    padding: ["10px", "16px"],
                                    "&:active": {
                                        backgroundColor: "rgba(0, 0, 0, 0.05)"
                                    }
                                }}
                            >
                                <Box>
                                    <Text
                                        mb={[0.5, 1]}
                                        color="blackAlpha.900"
                                        fontWeight="500"
                                        fontSize={["18px", "24px"]}
                                        lineHeight={["1.3", "1.4"]}
                                        fontFamily='sans-serif'
                                    >
                                        {position.title}
                                    </Text>
                                    <Box display="flex" alignItems="center" gap={["6px", "8px"]}>
                                        <Text
                                            fontSize={["13px", "16px"]}
                                            color="gray.600"
                                            lineHeight={["1.6", "1.8"]}
                                        >
                                            {position.location}
                                        </Text>
                                        {position.jobType &&
                                            <>
                                                <Text fontSize={["xs", "sm", "md"]} color="gray.600" lineHeight={["1.6", "1.8"]}>•</Text>
                                                <Badge
                                                    py={0.5}
                                                    px={1.5}
                                                    variant='surface'
                                                    borderRadius="3px"
                                                    textTransform="capitalize"
                                                    fontSize={["9px", "11px", "13px"]}
                                                >
                                                    {position.jobType}
                                                </Badge>
                                            </>
                                        }
                                    </Box>
                                </Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={2.5}
                                    className={styles.applySection}
                                >
                                    <Text
                                        fontSize={["14px", "16px", "18px"]}
                                        color="#141412"
                                        fontWeight="500"
                                        textDecoration="underline"
                                    >
                                        Apply
                                    </Text>
                                    <RxExternalLink size={iconSize} color="#141412" />
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>

                <Separator my={[8, 10]} />

                <Box
                    display="flex"
                    gap={[4, 6]}
                    flexDirection={["column", "row"]}
                    mt={[8, 10]}
                >
                    <Box
                        as="button"
                        flex="1"
                        p={[3, 4]}
                        bg="gray.100"
                        border="1px solid"
                        borderColor="gray.400"
                        borderRadius="2px"
                        _hover={{ bg: "gray.200", borderColor: "gray.500" }}
                        cursor="pointer"
                        onClick={() => window.open('https://durin.com', '_blank', 'noopener noreferrer')}
                    >
                        <Text fontSize={["md", "19px"]} fontWeight="500">
                            Main Website
                        </Text>
                    </Box>
                    <Box
                        as="button"
                        flex="1"
                        p={[3, 4]}
                        bg="gray.100"
                        border="1px solid"
                        borderColor="gray.400"
                        borderRadius="2px"
                        _hover={{ bg: "gray.200", borderColor: "gray.500" }}
                        cursor="pointer"
                        onClick={() => window.open('https://learn.durin.com', '_blank', 'noopener noreferrer')}
                    >
                        <Text fontSize={["md", "19px"]} fontWeight="500">
                            Learn About the Problem
                        </Text>
                    </Box>
                </Box>

            </Box>

            <Footer />
        </Box>
    );
};

export default Positions;